import { createContext, useContext } from 'react';

// Form-wide read-only, set once on `<Form readOnly>` and read by every
// `FormField` beneath it.
//
// A context rather than a prop on each field: a read-only form is a property of
// the FORM, and threading `disabled` through twenty call sites is a list that
// drifts the moment a field is added — the new one is editable and nothing
// says so. This way a field opts OUT (by setting its own `disabled`), never in.
//
// It carries no notion of WHY the form is read-only. A permission, a version
// preview and a locked record all reach the fields as the same fact; the reason
// belongs wherever the form is hosted, next to the words that explain it.
const FormReadOnlyContext = createContext(false);

export const FormReadOnlyProvider = FormReadOnlyContext.Provider;

/** `true` while the enclosing `<Form>` is read-only. */
export const useFormReadOnly = () => useContext(FormReadOnlyContext);
